<template>
  <section class="dashboard">
    <header-component class="dashboard-header" />
    <sidebar
      :toggleArrow="toggleArrow"
      :showMenu="showMenu"
      :class="[
        'dashboard-sidebar',
        { 'dashboard-sidebar_collapsed': getMenuState },
      ]"
      @collapse-toggle="sidebarToggle"
    />
    <div
      :class="[
        'dashboard-page',
        `dashboard-page--${$route.meta.theme ?? 'white-mist-bg'}`,
      ]"
    >
      <router-view v-if="userLoaded" :key="$route.path" />
    </div>
    <footer-component class="dashboard-footer" />
  </section>
</template>

<script>
import Sidebar from "@/common/components/Sidebar.vue";
import HeaderComponent from "@/common/components/HeaderComponent";
import FooterComponent from "@/common/components/FooterComponent";

export default {
  name: "DashboardLayout",
  components: { FooterComponent, HeaderComponent, Sidebar },
  data: () => ({
    isDashboardCollapsed: false,
    showMenu: false,
    toggleArrow: false,
  }),
  computed: {
    getMenuState() {
      return this.$store.getters.getMenuState;
    },
    userLoaded() {
      return (
        this.$store.state.auth?.oidc?.user != null || this.$route.meta.isPublic
      );
    },
  },
  methods: {
    sidebarToggle() {
      this.$store.dispatch("toggleMenuState");
      this.showMenu = !this.showMenu;
      this.toggleArrow = !this.toggleArrow;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.dashboard {
  min-height: 100vh;
  display: grid;
  transition: all 0.3s ease;
  grid-template:
    "sidebar header" 94px
    "sidebar content" auto
    "footer footer" 60px;
  grid-template-columns: min-content auto;
  @media (max-width: 1440px) {
    display: grid;
    transition: all 0.3s ease;
    grid-template:
      "sidebar header" 94px
      "sidebar content" auto
      "footer footer" 40px;
    grid-template-columns: min-content auto;
  }

  &-page {
    height: calc(100vh - 154px);
    grid-area: content;
    overflow-x: hidden;
    background-image: url("~@/assets/images/bg-puzzle.svg");
    background-repeat: no-repeat;
    background-position: bottom right;
    &--white-mist-bg {
      background-color: $white-mist-bg;
    }
    &--white {
      background-color: #fff;
    }
  }

  &-header {
    grid-area: header;
    z-index: 2;
  }

  &-footer {
    grid-area: footer;
  }

  &-sidebar {
    height: calc(100vh - 60px);
    grid-area: sidebar;
    z-index: 3;
    background-color: $white;
    border-left: 8px solid $blue-dark;
    overflow: hidden;
    width: 284px;
    will-change: width;
    transition: 0.3s width ease;

    :deep(.nav-title) {
      transition-delay: 0.3s;
      width: 1px;
      white-space: nowrap;
    }

    &_collapsed {
      border: none;
      width: 72px;
      background-color: $blue-dark;

      :deep(.nav-title) {
        width: 0;
        display: none;
      }
    }
  }
}
</style>
